import * as React from 'react';
import * as PropTypes from 'prop-types';
import RCSegmented from 'rc-segmented';
import classNames from 'classnames';
import { ConfigConsumer } from '../config-provider';
import 'rc-segmented/assets/index.css';
class Segmented extends React.Component {
    constructor() {
        super(...arguments);
        this.renderSegmented = ({ getPrefixCls }) => {
            const { prefixCls: customizePrefixCls, className, style, options, value, defaultValue, onChange, disabled, } = this.props;
            const prefixCls = getPrefixCls('segmented', customizePrefixCls);
            return (<RCSegmented className={classNames(className, prefixCls)} style={style} options={options} value={value} defaultValue={defaultValue} onChange={onChange} disabled={disabled}/>);
        };
    }
    render() {
        return <ConfigConsumer>{this.renderSegmented}</ConfigConsumer>;
    }
}
Segmented.propTypes = {
    prefixCls: PropTypes.string,
};
export default Segmented;
